import R from "ramda";
import { useCookie } from "react-recipes";
import { useSelector } from "react-redux";

import { useOffersActions } from "store/OffersSlice";
import useRouter from "hooks/useRouter";
import useOfferGroups from "hooks/useOfferGroups";
import { jjLogger } from "utils/logUtils";

const OFFER_COOKIE_EXPIRE_DAYS = 14;

const useOffers = () => {
  const { loadOffer } = useOffersActions();
  const { defaultOffer, loadOfferGroups } = useOfferGroups();
  const { offer } = useSelector((state) => state.OffersSlice);

  const {
    query: { offer: queryOffer = null },
  } = useRouter();

  const [currentOfferId, setCurrentOfferId] = useCookie("offer");

  const setCurrentOffer = () => {
    if (!R.isNil(queryOffer)) {
      setCurrentOfferId(queryOffer, OFFER_COOKIE_EXPIRE_DAYS);
    }
  };

  const fetchOffer = async (offerId) => {
    try {
      await loadOffer(offerId);
    } catch (e) {
      jjLogger.logError(
        `useOffers.js - fetchOffer() - Error: Could not load offer "${offerId}". ${e?.message ? e.message : e}`,
      );
      await loadOfferGroups();
    }
  };

  const loadCurrentOffer = async () => {
    R.isNil(currentOfferId) ? await loadOfferGroups() : await fetchOffer(currentOfferId);
  };

  return {
    currentOffer: offer || defaultOffer,
    fetchOffer,
    setCurrentOffer,
    loadCurrentOffer,
  };
};

export default useOffers;
